import { CTA_URL } from "../data/site";
import { trackSubscribe } from "../lib/pixel";
import Reveal from "./Reveal";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="relative overflow-hidden border-t border-emerald/15 bg-forest">
      <div className="mx-auto max-w-7xl px-5 pb-10 pt-20 sm:px-8 md:pt-28">
        <Reveal>
          <p data-testid="footer-slogan" className="mx-auto max-w-4xl text-center text-4xl font-black leading-[1.05] tracking-tight text-cream sm:text-6xl md:text-7xl">
            Trade once,
            <br />
            <span className="italic text-goldlight">double the profits.</span>
          </p>
          <p data-testid="footer-subline" className="mt-6 text-center text-xs font-bold tracking-[0.35em] text-gold sm:text-sm md:text-base">
            ASIA'S HIGHEST REBATE
          </p>
        </Reveal>
        <div className="mt-16 flex flex-col items-center gap-6 border-t border-emerald/15 pt-8 text-center md:flex-row md:justify-center md:gap-10">
          <Logo />
          <a
            data-testid="footer-telegram-link"
            href={CTA_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={trackSubscribe}
            className="text-sm font-light text-sage transition-colors duration-300 hover:text-goldlight"
          >
            Telegram: t.me/RaidRTM
          </a>
          <p className="text-xs font-light text-sage/70">
            Khusus akun BOOSTER.
            <br className="md:hidden" /> Syarat &amp; ketentuan program berlaku.
          </p>
        </div>
      </div>
    </footer>
  );
}
